module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.75795c57.svg";